var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrihow = function SvgIconTrihow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M3 14.334v-3.09Q4.524 10.186 5.153 9.1q.63-1.087.873-1.933H4.289v-1h1.634a2.8 2.8 0 0 1-.492-.796 2.5 2.5 0 0 1-.181-.954q0-1.146.803-1.948A2.65 2.65 0 0 1 8 1.667a2.65 2.65 0 0 1 1.948.802q.801.802.801 1.948 0 .511-.181.954t-.492.796h1.641v1h-1.73q.236.84.862 1.93T13 11.243v3.09zm1-1h8v-1.552q-1.405-1.11-2.082-2.298-.677-1.19-.968-2.317H7.056q-.29 1.128-.97 2.317Q5.404 10.672 4 11.782zm4.002-7.167q.737 0 1.242-.508.506-.507.506-1.242t-.507-1.243a1.69 1.69 0 0 0-1.241-.507q-.735 0-1.243.507-.51.508-.509 1.243 0 .735.508 1.242.509.508 1.244.508"
  })));
};
export default SvgIconTrihow;